export default __webpack_public_path__ + "static/media/LLL Section 2 Preview.2a9fcae6.png";